import { useEffect } from 'react';

interface PortfolioItem {
  id: number;
  image: string;
  title: string;
  category: string;
  categoryId: string;
  description: string;
}

interface ImageModalProps {
  item: PortfolioItem;
  onClose: () => void;
}

export default function ImageModal({ item, onClose }: ImageModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors duration-300 cursor-pointer"
      >
        <i className="ri-close-line text-2xl"></i>
      </button>

      <div 
        className="max-w-5xl w-full bg-white rounded-2xl overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative aspect-[4/3] bg-slate-100">
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-contain"
          />
        </div>
        <div className="p-8">
          <div className="inline-block px-4 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-semibold mb-3">
            {item.category}
          </div>
          <h2 className="text-3xl font-bold text-slate-900 mb-3">{item.title}</h2>
          <p className="text-lg text-slate-600">{item.description}</p>
        </div>
      </div>
    </div>
  );
}
